import React from 'react';

import CN from './DepositPrompt.module.scss';

const DepositPrompt = ({ children }) => (
  <div data-bem="DepositPrompt" className={CN.container}>
    {children}
    <div className={CN.top} />
    <div className={CN.middle} />
    <div className={CN.bottom} />
  </div>
);

export default DepositPrompt;
